import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../hooks/useAuth';
import '../styles/SiteConfig.css';

const SiteConfig = () => {
  const { token } = useAuth();
  const [forceLoading, setForceLoading] = useState(false);
  const [confirmForce, setConfirmForce] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const baseURL = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5001';

  const handleForceUpdate = async () => {
    if (!confirmForce) {
      setConfirmForce(true);
      return;
    }

    setForceLoading(true);
    setStatusMessage(null);
    try {
      await axios.post(
        `${baseURL}/hospital-portal/api/version/notify`,
        { force: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatusMessage({ type: 'success', text: 'Force update sent to all connected users.' });
    } catch (err) {
      setStatusMessage({ 
        type: 'error', 
        text: err.response?.data?.message || 'Failed to send force update.' 
      });
    } finally {
      setForceLoading(false);
      setConfirmForce(false);
    }
  };

  const handleCancel = () => {
    setConfirmForce(false);
  };

  return (
    <div className="site-config-page">
      <h2 className="site-config-title">Site Configuration</h2>

      <div className="site-config-section">
        <h3 className="site-config-section-title">Version Management</h3>
        <p className="site-config-description">
          Force all connected users to immediately refresh their browser. 
          Use this after deploying a critical security update that cannot wait 
          for the normal 10-minute grace period.
        </p>
        <div className="site-config-warning">
          <span className="site-config-warning-icon">&#x26A0;</span>
          <span>
            This will interrupt all active users. They will see a full-screen 
            overlay requiring them to refresh. Any unsaved work may be lost.
          </span>
        </div>

        {statusMessage && (
          <div className={`site-config-status site-config-status-${statusMessage.type}`}>
            {statusMessage.text}
          </div>
        )}

        <div className="site-config-actions">
          {!confirmForce ? (
            <button
              className="site-config-btn site-config-btn-danger"
              onClick={handleForceUpdate}
              disabled={forceLoading}
            >
              Force Update All Users
            </button>
          ) : (
            <div className="site-config-confirm">
              <p className="site-config-confirm-text">
                Are you sure? All users will be forced to refresh immediately.
              </p>
              <button
                className="site-config-btn site-config-btn-danger"
                onClick={handleForceUpdate}
                disabled={forceLoading}
              >
                {forceLoading ? 'Sending...' : 'Yes, Force Update'}
              </button>
              <button
                className="site-config-btn site-config-btn-cancel"
                onClick={handleCancel}
                disabled={forceLoading}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SiteConfig;
